import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'appendAsterisk',
	standalone: true,
})
/**
 * Appends an asterisk to a value to represent that said value is 'required'.
 */
export class LvrAppendAsteriskPipe implements PipeTransform {
	public transform(value: string): string {
		return `${value}*`;
	}
}
